import { render } from "./daytwo-grid.vue?vue&type=template&id=ea12a30e"
import script from "./daytwo-grid.vue?vue&type=script&lang=js"
export * from "./daytwo-grid.vue?vue&type=script&lang=js"
script.render = render

export default script